import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { toggleField as ToggleField } from 'ui/views/generic/toggleField';
 *
 * // render
 * <ToggleField propName='propValue'/>
 */
export const toggleField = ( props ) => {

    const toggleClassName = classnames( 'ui-toggle-field', props.className );

    return (
        <div className={ toggleClassName } style= {{ height: props.height, width: props.width }}>
            <input type='checkbox' className='ui-toggle-field__input' onChange= { props.onChange } style={{ height: props.height }} checked={ props.value }/>
            <div className='ui-toggle-field__bar'></div>
            <div className='ui-toggle-field__knob' style={{ height: props.height - 6, width: props.width / 2  }}></div>
        </div>
    );
};

// set display name
toggleField.displayName = 'toggleField';

// set default props
toggleField.defaultProps = {
    width: 100,
    height: 50,
    value: false
};

// prop types
toggleField.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    value: PropTypes.bool
};
